import React, {useEffect, useState} from 'react'
import {useLocation} from "react-router-dom";
import FromFieldText from '../../atoms/FromFieldText';
import {getCompanyProfileList} from '../../services/user.service';
import {getYearNameInfo, saveYearName} from '../../services/asset.service';
import * as CryptoJS from "crypto-js";

//const TEXT_REGEX = /^[a-zA-Z0-9-_ ]{1,255}$/;
const TEXT_REGEX = /^[A-Za-z0-9-_/.@= ]{1,155}$/;

function AddTypeYearOfAddition() {

    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);

    const [companyId, setCompanyId] = useState('');
    const [ErrCompanyId, setErrCompanyId] = useState(false);

    const [yearname, setYearName] = useState('');
    const [ErrYearName, setErrYearName] = useState(false);

    const [selectedYear, setSelectedYear] = useState('');
    const [ErrYearShortCode, setErrShortCode] = useState(false);

    const [companies, setCompanies] = useState([]);

    const currentYear = new Date().getFullYear();

    const resetUserInfo = function () {
        setYearName('');
        setCompanyId('');
        setSelectedYear('');
    }

    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const YearID = query.get('yearid');


    //const elementRef = useRef();
    useEffect(() => {
        if (YearID !== '' && YearID != null) {
            const decryptedBytes = CryptoJS.AES.decrypt(YearID.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
            const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
            const yearListId = decrypt_data.yearId;
            getYearData(yearListId);
        }

        const EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();

        const oData = {'token': EncryptData};
        getCompanyProfileList(oData).then(res => {
            if (res?.data?.data?.length) setCompanies(res.data.data);
        });
    }, [YearID]);

    const getYearData = function (yearListId) {
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': {'yearId': yearListId},
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData1 = {'token': EncryptData}
        getYearNameInfo(oData1).then(function (res) {
            ////console.log(res.data.data);
            if (res?.data?.data) {
                var divisInfo = res.data.data[0];
                setCompanyId(divisInfo.company_id);
                setYearName(divisInfo.year_of_addition);
                setSelectedYear(divisInfo.year_short_name);
            }
        })
    }
    const handleCompanyId = (e) => {
        setCompanyId(e.target.value);
    }
    const handleYearChange = (e) => {
        setSelectedYear(e.target.value);
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        var valid_Name = true;
        // if button enabled with JS hack
        //const v1 = TEXT_REGEX.test(name);
        if (!TEXT_REGEX.test(companyId)) { //alert(companyId);
            setErrCompanyId('Company name is required');
            valid_Name = false; //alert(valid_Name);
            //return;
        } else {
            setErrCompanyId('');
        }
        if (!TEXT_REGEX.test(yearname)) { //alert(name);
            setErrYearName('Year name is required');
            valid_Name = false; //alert(valid_Name);
            //return;
        } else {
            setErrYearName('');
        }
        if (!TEXT_REGEX.test(selectedYear)) {
            setErrShortCode('Year short code is required');
            valid_Name = false;
        } else {
            setErrShortCode('');
        }

        if (valid_Name) { //alert('test1');
            saveData(); //submit form
        } else {  //alert('fa');
            return false;
        }
    }

    const saveData = function () {
        try {


            if (YearID !== '' && YearID !== null) {
                const decryptedBytes = CryptoJS.AES.decrypt(YearID.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
                // Convert the decrypted bytes to a string
                const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
                const decryptedYearId = decrypt_data.yearId;
                var obj = {
                    'year_id': decryptedYearId,
                    'year_short_name': selectedYear,
                    'year_of_addition': yearname,
                    'company_id': companyId,
                    'status': '1',
                    'created_by': sessionStorage.getItem('LoggedInUserId'),
                }
            } else {
                var obj = {
                    'year_short_name': selectedYear,
                    'year_of_addition': yearname,
                    'company_id': companyId,
                    'status': '1',
                    'created_by': sessionStorage.getItem('LoggedInUserId'),
                }
            }


            //encrypted data
            let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data': obj,
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            let oData = {'token': EncryptData}

            saveYearName(oData).then(function (res) {
                //console.log(res);
                if ((typeof (res.data.errors) != "undefined") && res.data.errors.errno > 0) {
                    setErrMsg(res.data.message);
                    setSuccess(false);
                } else {
                    setSuccess(res.data.message);
                    resetUserInfo();
                }
            });

            //setValidName(false);
        } catch (err) {
            setSuccess(false);
            if (!err?.data) {
                //console.log(err);
                setErrMsg('No Server Response');
            } else if (err.data?.status === 409) {
                setErrMsg('data already exist');
            } else {
                setErrMsg('Insert/Update Failed');
            }
            //elementRef.current.focus();
        }
    }
    return (
        <div className="container">

            <div className="row">
                <div className="col-6">
                    <h5>Add Year Of Addition</h5>
                </div>
                <div className="invalid-feedback" role="alert">
                    <i className="fa fa-info-circle"></i>
                    Please Fill all mandatory field.
                </div>

                {success ? (
                    <div className="alert alert-success" role="alert"><i
                        className="bi bi-check-circle-fill"></i>{success}</div>
                ) : (errMsg ? (<div className="alert alert-danger" role="alert"><i
                        className="bi bi-exclamation-triangle-fill"></i>{errMsg}</div>) : ('')
                )}
            </div>

            <div className='row '>
                <div className='col-12'>&nbsp;</div>

            </div>
            <form onSubmit={handleSubmit}>
                <div className="row form-fields">
                    <div className="label col-3">
                        <label>Company </label><span className="star error"> *</span>
                    </div>

                    <div className="item col-3">
                        <select className="form-select form-select-sm mb-3" onChange={handleCompanyId}>
                            <option value="">Select Company</option>
                            {companies && companies.length > 0 ? (
                                companies.map((option) => (
                                    <option value={option.company_id}
                                            selected={(option.company_id == companyId) ? "selected" : ''}>{option.company_name}</option>
                                ))
                            ) : (
                                <option value="">No Data</option>
                            )}
                        </select>
                        <span className="invalid-feedback"> {ErrCompanyId} </span>
                    </div>
                </div>

                <div className="row mt-2">
                    <div className="col-6">
                        <FromFieldText star="*"
                                       label="Year Name"
                                       inputValue={yearname}
                                       setInputValue={setYearName}
                                       setErrorMsg={ErrYearName}
                        />
                    </div>
                    <div className="col-6"></div>
                </div>

                <div className="row form-fields mt-2">
                    <div className="label col-3">
                        <label>Select Year Short Code </label><span className="star error"> *</span>
                    </div>

                    <div className="item col-3">
                        <select className="form-select form-select-sm mb-3" onChange={handleYearChange}
                                value={selectedYear}>
                            <option value="">Select Year</option>
                            {Array.from({length: currentYear - 2000}, (_, i) => 2001 + i).map(year => (
                                <option key={year} value={year}>{year}</option>
                            ))}
                        </select>
                        <span className="invalid-feedback"> {ErrYearShortCode} </span>
                    </div>

                </div>

                <div className="row mt-2">
                    <div className="col-3"></div>
                    <div className="col-6">
                        <button className="btn btn-primary  btn-sm"> SAVE</button>


                    </div>
                    <div className="col-3"></div>
                </div>
            </form>
        </div>
    )
}

export default AddTypeYearOfAddition


